<table *ngIf='showTable' mat-table [dataSource]="tableData" class="details-screen-table table-scrollbar">
  <ng-container matColumnDef="incassant">
    <th mat-header-cell *matHeaderCellDef> Incassant / Inzake </th>
    <td mat-cell *matCellDef="let data"> {{ formIncassant(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="machtiging">
    <th mat-header-cell *matHeaderCellDef> Machtiging </th>
    <td mat-cell *matCellDef="let data"> {{ formMachtiging(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="omscrijving">
    <th mat-header-cell *matHeaderCellDef> Omscrijving </th>
    <td mat-cell *matCellDef="let data"> {{ formOmscrijving(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="datumIngevoerd">
    <th mat-header-cell *matHeaderCellDef> Datum Ingevoerd </th>
    <td mat-cell *matCellDef="let data"> {{ formDatumIngevoerd(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="soort">
    <th mat-header-cell *matHeaderCellDef> Soort </th>
    <td mat-cell *matCellDef="let data"> {{ formSoort(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="maxBedrag">
    <th mat-header-cell *matHeaderCellDef> Max Bedrag </th>
    <td mat-cell *matCellDef="let data"> {{ formMaxBedrag(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let data"> {{ formStatus(data) }} </td>
  </ng-container>

  <ng-container matColumnDef="laatsteDatumBedrag">
    <th mat-header-cell *matHeaderCellDef> Laatste incasso datum en bedrag </th>
    <td mat-cell *matCellDef="let data"> {{ formLatestDateAndAmount(data) }} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
